import Vue from 'vue'
import Router from 'vue-router'
import MemberValidation from '../views/MemberValidation.vue'
import CreateProfile from '../views/CreateProfile.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'MemberValidation',
      component: MemberValidation
    }, {
      path: '/CreateProfile',
      name: 'CreateProfile',
      component: CreateProfile,
      beforeEnter: (to, from, next) => {
        // If the user isn't coming from memberValidation, redirect it there
        if (from.name !== 'MemberValidation') {
          next({name: 'MemberValidation'})
        } else {
          next()
        }
      }
    }, {
      path: '*',
      redirect: 'MemberValidation'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js